export default __webpack_public_path__ + "images/NW.3b961d1.png";